// Saint of the day for each (month, day-of-month-minus-1).
// Ported verbatim from http://www.almanach.free.fr/js/calendar_v2.js
// (re-encoded from ISO-8859-1 to UTF-8).
// February has 29 entries; index 28 is only used in leap years.

export const SAINTS: readonly (readonly string[])[] = [
  // janvier (31)
  [
    "JOUR de l'AN", 'Basile', 'Geneviève', 'Odilon', 'Edouard', 'Mélainie', 'Raymond',
    'Lucien', 'Alix', 'Guillaume', 'Paulin', 'Tatiana', 'Yvette', 'Nina',
    'Rémi', 'Marcel', 'Roseline', 'Prisca', 'Marius', 'Sébastien', 'Agnès',
    'Vincent', 'Barnard', 'Fr. de Sales', 'Conv. S. Paul', 'Paul', 'Angèle', "Th. d'Aquin",
    'Gildas', 'Martine', 'Marcelle',
  ],
  // février (29)
  [
    'Ella', 'Présentation', 'Blaise', 'Véronique', 'Agathe', 'Gaston', 'Eugénie',
    'Jacqueline', 'Appoline', 'Arnaud', 'N.-D. Lourdes', 'Félix', 'Béatrice', 'Valentin',
    'Claude', 'Julienne', 'Alexis', 'Bernadette', 'Gabin', 'Aimée', 'P. Damien',
    'Isabelle', 'Lazare', 'Modeste', 'Roméo', 'Nestor', 'Honorine', 'Romain',
    'Auguste',
  ],
  // mars (31)
  [
    'Aubin', 'Charles le B.', 'Guénolé', 'Casimir', 'Olive', 'Colette', 'Félicité',
    'Jean de Dieu', 'Françoise', 'Vivien', 'Rosine', 'Justine', 'Rodrigue', 'Mathilde',
    'Louise', 'Bénédicte', 'Patrice', 'Cyrille', 'Joseph', 'PRINTEMPS', 'Clémence',
    'Léa', 'Victorien', 'Cath. de Suè.', 'Humbert', 'Larissa', 'Habib', 'Gontran',
    'Gwladys', 'Amédée', 'Benjamin',
  ],
  // avril (30)
  [
    'Hugues', 'Sandrine', 'Richard', 'Isidore', 'Irène', 'Marcellin', 'J.-B. de la S.',
    'Julie', 'Gauthier', 'Fulbert', 'Stanislas', 'Jules', 'Ida', 'Maxime',
    'Paterne', 'Benoît-J.', 'Anicet', 'Parfait', 'Emma', 'Odette', 'Anselme',
    'Alexandre', 'Georges', 'Fidèle', 'Marc', 'Alida', 'Zita', 'Jour du Souv.',
    'Cath. de Si.', 'Robert',
  ],
  // mai (31)
  [
    'F. du TRAVAIL', 'Boris', 'Phil., Jacq.', 'Sylvain', 'Judith', 'Prudence', 'Gisèle',
    'Victoire 45', 'Pacôme', 'Solange', 'Estelle', "Jean.-d'Arc", 'Rolande', 'Matthias',
    'Denise', 'Honoré', 'Pascal', 'Eric', 'Yves', 'Bernardin', 'Constantin',
    'Emile', 'Didier', 'Donatien', 'Sophie', 'Bérenger', 'Augustin', 'Germain',
    'Aymar', 'Ferdinand', 'Visitation',
  ],
  // juin (30)
  [
    'Justin', 'Blandine', 'Kévin', 'Clotilde', 'Igor', 'Norbert', 'Gilbert',
    'Médard', 'Diane', 'Landry', 'Barnabé', 'Guy', 'Antoine de P.', 'Elisée',
    'Germaine', 'J.-Fr. Régis', 'Hervé', 'Léonce', 'Romuald', 'Silvère', 'ETE',
    'Alban', 'Audrey', 'Jean-Bapt.', 'Prosper', 'Anthelme', 'Fernand', 'Irénée',
    'Pierre, Paul', 'Martial',
  ],
  // juillet (31)
  [
    'Thierry', 'Martinien', 'Thomas', 'Florent', 'Antoine', 'Mariette', 'Raoul',
    'Thibault', 'Amandine', 'Ulrich', 'Benoît', 'Olivier', 'Henri, Joël', 'FETE NATION.',
    'Donald', 'N-D Mt-Carmel', 'Charlotte', 'Frédéric', 'Arsène', 'Marina', 'Victor',
    'Marie-Mad.', 'Brigitte', 'Christine', 'Jacques', 'Anne, Joach.', 'Nathalie', 'Samson',
    'Marthe', 'Juliette', 'Ignace de L.',
  ],
  // août (31)
  [
    'Alphonse', 'Julien-Eym.', 'Lydie', 'J.-M. Vianney', 'Abel', 'Transfiguration', 'Gaétan',
    'Dominique', 'Amour', 'Laurent', 'Claire', 'Clarisse', 'Hippolyte', 'Evrard',
    'ASSOMPTION', 'Armel', 'Hyacinthe', 'Hélène', 'Jean-Eudes', 'Bernard', 'Christophe',
    'Fabrice', 'Rose de L.', 'Barthélemy', 'Louis', 'Natacha', 'Monique', 'Augustin',
    'Sabine', 'Fiacre', 'Aristide',
  ],
  // septembre (30)
  [
    'Gilles', 'Ingrid', 'Grégoire', 'Rosalie', 'Raïssa', 'Bertrand', 'Reine',
    'Nativité N.-D.', 'Alain', 'Inès', 'Adelphe', 'Apollinaire', 'Aimé', 'La Ste Croix',
    'Roland', 'Edith', 'Renaud', 'Nadège', 'Emilie', 'Davy', 'Matthieu',
    'Maurice', 'AUTOMNE', 'Thècle', 'Hermann', 'Côme, Dam.', 'Vinc. de P.', 'Venceslas',
    'Michel', 'Jérôme',
  ],
  // octobre (31)
  [
    "Thér. de l'E.", 'Léger', 'Gérard', "Fr. d'Assise", 'Fleur', 'Bruno', 'Serge',
    'Pélagie', 'Denis', 'Ghislain', 'Firmin', 'Wilfried', 'Géraud', 'Juste',
    "Thér. d'Avila", 'Edwige', 'Baudoin', 'Luc', 'René', 'Adeline', 'Céline',
    'Elodie', 'Jean de C.', 'Florentin', 'Crépin', 'Dimitri', 'Emeline', 'Simon, Jude',
    'Narcisse', 'Bienvenue', 'Quentin',
  ],
  // novembre (30)
  [
    'TOUSSAINT', 'Défunt', 'Hubert', 'Charles', 'Sylvie', 'Bertille', 'Carine',
    'Geoffroy', 'Théodore', 'Léon', 'ARMISTICE', 'Christian', 'Brice', 'Sidoine',
    'Albert', 'Marguerite', 'Elisabeth', 'Aude', 'Tanguy', 'Edmond', 'Prés. Marie',
    'Cécile', 'Clément', 'Flora', 'Cath. L.', 'Delphine', 'Séverin', 'Jacq. de la M.',
    'Saturnin', 'André',
  ],
  // décembre (31)
  [
    'Florence', 'Viviane', 'Xavier', 'Barbara', 'Gérald', 'Nicolas', 'Ambroise',
    'Im. Concept.', 'Pierre Fourier', 'Romaric', 'Daniel', 'Jean. Fr.-Ch.', 'Lucie', 'Odile',
    'Ninon', 'Alice', 'Gaël', 'Gatien', 'Urbain', 'Abraham', 'Pierre C.',
    'HIVER', 'Armand', 'Adèle', 'NOËL', 'Etienne', 'Jean', 'Innocents',
    'David', 'Roger', 'Sylvestre',
  ],
];

export function saintFor(month: number, day: number): string {
  return SAINTS[month]?.[day - 1] ?? '';
}
